interface ListCardShimmerProps {
  count?: number;
}

const ListCardShimmer: React.FC<ListCardShimmerProps> = ({ count = 1 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="border border-[#DCDDE0] rounded-2xl px-4 py-[18px] flex items-center gap-3 animate-pulse shrink-0"
      >
        <div className="w-10 h-10 rounded-full bg-[#ECEEEF] shrink-0" />
        <div className="flex flex-col gap-2 flex-1">
          <div className="h-4 bg-[#ECEEEF] rounded w-2/5" />
          <div className="h-3 bg-[#ECEEEF] rounded w-1/5" />
        </div>
        <div className="w-8 h-8 rounded-full bg-[#ECEEEF] shrink-0" />
      </div>
    ))}
  </>
);

export default ListCardShimmer;
